<template>
	<div class="container-fluid">
			<div class="row">
				<div class="col-12 col-xl-10">
					<div class="row align-items-center justify-content-between">
						<div class="col-12 col-lg-4">
							<h3 class="mt-0 mb-4 pb-2 pt-2">My profile</h3>
						</div><!--col-->
					</div><!--row-->
				</div><!--col-->
			</div><!--row-->
			<div class="row">
				<div class="col-12 col-xl-10" v-if="user">
					<form @submit.prevent="onSubmit" class="mb-5">
						<div class="row">
							<div class="col-12">
								<div class="lightgray-content p-3 rounded mb-2">
									<div class="row">
										<div class="col-12 col-lg-4">
											<div class="form-group input-content">
												
												<picture-input 
											      ref="pictureInput"
											      accept="image/jpeg,image/png" 
											      size="10" 
											      button-class="button"
											      :custom-strings="{
											        upload: '<h1>Bummer!</h1>',
											        drag: 'Drag or click to upload an image'
											      }"
											      :prefill="user.image"
											      @change="onChange">
											    </picture-input>

											</div>
											
										</div><!--col-->
										<div class="col-12 col-lg-4">

											<div class="form-group input-content">
												<label>Name</label>
												<input placeholder="Name" type="text" class="form-control" v-validate="'required'" name="name" v-model="user.name" autocomplete="off">
												<span class="input-error-msg">{{ errors.first('name') }}</span>
											</div>
											<div class="form-group input-content">
												<label>Email</label>
												<input placeholder="Email" type="text" disabled  class="form-control" v-model="user.email">
											</div>
											<!-- <div class="form-group input-content">
												<label>Change password</label>
												<input placeholder="New password" type="password" class="form-control" v-model="password"
														v-validate="'min:6'" name="password" autocomplete="off">
												<span class="input-error-msg">{{ errors.first('password') }}</span>
											</div> -->
										</div><!--col-->
									</div><!--row-->
								</div><!--lightgray_content-->
								<div class="text-right">
									<button type="submit" class="large-button button">Update</button>
								</div>
							</div><!--col-->
						</div><!--row-->
					</form>
				</div><!--col-->
			</div><!--row-->
		</div><!--container-->
</template>

<script>
import PictureInput from 'vue-picture-input';
export default {

	data : function(){
		return {
			// password : null,
			image : null,
			show_picture_input : false
		}
	},
	components: {
		PictureInput
	},

	computed : {
		user : function(){
			return this.$store.getters.getUser;
		}
	},
	created : function(){
		
	}, 

	methods : {
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					var data = {
						name : this.user.name,
						// password : this.password,
						image : this.image
					}

					this.$store.dispatch('editProfile', data).then((res) => {
						
						// this.password = '';
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},
		onChange (image) {
			if (image) {
				this.image = image;
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/shared/profile/ProfileEditComponent.vue